module.exports = __webpack_public_path__ + "media/images/brand/app_text_150-438d85f9b104e041cf8b79af4a3caa15.png";